import React from 'react';
import { Lock, AlertTriangle } from 'lucide-react';

const FIELD_LABELS = {
  start_date: 'Date', end_date: 'Date', duration_days: 'Duration', start_time: 'Time', end_time: 'Time',
  location: 'Location', venue_details: 'Venue', recurring_schedule: 'Repeat schedule',
  is_online: 'In person / Online', meeting_link: 'Meeting link',
};

export const EditLockNote = ({ count, testId, text = 'Locked' }) => (
  <div data-testid={testId} style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 6, fontSize: 11, color: '#92400E' }}>
    <Lock size={12} /> {text} because {count} {count === 1 ? 'person has' : 'people have'} joined.
  </div>
);

export const MaterialChangeModal = ({ prompt, onCancel, onConfirm, busy }) => {
  const fields = [...new Set((prompt.fields || []).map(f => FIELD_LABELS[f] || f))];
  const n = prompt.joined_count;
  return (
    <div data-testid="material-change-modal" onClick={onCancel} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: 16, padding: 22, width: '100%', maxWidth: 380, boxShadow: '0 12px 40px rgba(0,0,0,0.18)' }}>
        <div style={{ width: 44, height: 44, borderRadius: 12, background: '#FEF3C7', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12 }}>
          <AlertTriangle size={22} color="#D97706" />
        </div>
        <h3 style={{ margin: 0, fontSize: 17, fontWeight: 700, color: '#1F2937' }}>Notify {n} {n === 1 ? 'person' : 'people'}?</h3>
        <p data-testid="material-change-message" style={{ margin: '8px 0 0', fontSize: 13, color: '#4B5563', lineHeight: 1.5 }}>
          You changed the <b>{fields.join(', ').toLowerCase()}</b>. Everyone who joined will get an in-app notification about this change.
        </p>
        <div style={{ display: 'flex', gap: 10, marginTop: 18 }}>
          <button data-testid="material-change-cancel" onClick={onCancel} disabled={busy} style={{ flex: 1, padding: 12, borderRadius: 12, border: '1px solid #E5E7EB', background: '#fff', fontSize: 14, fontWeight: 600, color: '#374151', cursor: 'pointer' }}>Go back</button>
          <button data-testid="material-change-confirm" onClick={onConfirm} disabled={busy} style={{ flex: 1, padding: 12, borderRadius: 12, border: 'none', background: '#4DB6AC', fontSize: 14, fontWeight: 700, color: '#fff', cursor: busy ? 'wait' : 'pointer', opacity: busy ? 0.7 : 1 }}>{busy ? 'Saving...' : 'Save & notify'}</button>
        </div>
      </div>
    </div>
  );
};
